module.exports = [{
      plugin: require('/Users/Maciek/dev/wtl-creator/web/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
